import React from 'react'
import ButtonLink, { ButtonLinkProps } from 'components/shared/ButtonLink'

const MoreDetailsButton: React.FC<Omit<ButtonLinkProps, 'text'>> = ({ ...props }) => {
  return <ButtonLink text='Details' size='large' bold {...props} />
}

export default MoreDetailsButton
